// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8fb7f356","453":"2b03b192","455":"6e329a19","977":"627a71d5"}[chunkId] + ".chunk.js";
};